import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { IEditableInline } from 'src/app/api/ieditable-inline';
import { IPerformanceBodEdsIe } from 'src/app/api/performance-bod-eds-ie';
import { InlineEditService } from 'src/app/services/inline-edit.service';
import { PerformanceBodDataService } from 'src/app/services/performance-bod-data.service';
import { PerformanceBodStoreService } from 'src/app/services/performance-bod-store.service';
import * as Helpers from 'src/app/_shared/helpers';

@Injectable({
  providedIn: 'root',
})
export class PerformanceBodEdsIeService extends InlineEditService implements IEditableInline {
  public data: IPerformanceBodEdsIe[] = [];
  public originalData: IPerformanceBodEdsIe[] = [];
  public createdItems: IPerformanceBodEdsIe[] = [];
  public updatedItems: IPerformanceBodEdsIe[] = [];
  public deletedItems: IPerformanceBodEdsIe[] = [];
  public performanceBodId: string;

  constructor(
    private performanceBodDataService: PerformanceBodDataService
  ) {
    super();
  }

  public isNew(item: any): boolean {
    return !item.id;
  }

  public itemIndex(item: any, data: IPerformanceBodEdsIe[]): number {
    for (let idx = 0; idx < data.length; idx++) {
      if (data[idx].id === item.id) {
        return idx;
      }
    }
    return -1;
  }

  public create(): Observable<any> {
    return this.performanceBodDataService.createPerformanceBodEdsIe(this.createdItems);
  }

  public retrieve(): Observable<any> {
    return     this.performanceBodDataService.getPerformanceBodEdsIe(this.performanceBodId).pipe(map(data => {
      data.forEach(element => {
        if (element.readyForServiceDate !== null && element.readyForServiceDate !== undefined) {
          element.readyForServiceDate = Helpers.convertUtcToLocalTime(element.readyForServiceDate);
        } else {
          element.readyForServiceDate = undefined;
        }

        if (element.permitsRequiredBy !== null && element.permitsRequiredBy !== undefined) {
          element.permitsRequiredBy = Helpers.convertUtcToLocalTime(element.permitsRequiredBy);
        } else {
          element.permitsRequiredBy = undefined;
        }
      });

      return data;
    }))
  }

  public update(): Observable<any> {
    return this.performanceBodDataService.updatePerformanceBodEdsIe(this.updatedItems);
  }

  public delete(): Observable<any> {
    return this.performanceBodDataService.updatePerformanceBodEdsIe(this.deletedItems);
  }

}
